import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check, Package, Truck, Home, Clock } from "lucide-react";
import api from "@/lib/api";

const STEPS = [
  { key: "pending", label: "Order Placed", icon: Clock },
  { key: "paid", label: "Payment Confirmed", icon: Check },
  { key: "processing", label: "Preparing", icon: Package },
  { key: "shipped", label: "Shipped", icon: Truck },
  { key: "delivered", label: "Delivered", icon: Home },
];
const ORDER = ["pending", "paid", "processing", "shipped", "delivered"];

export default function TrackOrder() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/track/${orderNumber}`).then(({ data }) => setOrder(data)).catch(() => setOrder(false));
  }, [orderNumber]);

  const idx = order ? Math.max(ORDER.indexOf(order.status), 0) : 0;

  return (
    <div className="max-w-2xl mx-auto px-6 py-24" data-testid="track-order-page">
      <p className="font-body uppercase tracking-luxe text-[0.6rem] text-ink/40 text-center mb-3">Order Tracking</p>
      <h1 className="font-heading text-4xl md:text-5xl text-center mb-2">Your Voyage</h1>

      {order === false && (
        <p className="text-center font-body text-sm text-ink/50 mt-10" data-testid="track-not-found">
          We couldn't find that order. Please check the number and try again.
        </p>
      )}

      {order && order !== true && order.order_number && (
        <div className="mt-12" data-testid="track-detail">
          <div className="text-center mb-14">
            <p className="font-body text-sm text-ink/50">Order</p>
            <p className="font-heading text-2xl tracking-tight" data-testid="track-order-number">{order.order_number}</p>
            <p className="font-body text-xs text-ink/40 mt-1">{order.item_count} item{order.item_count !== 1 ? "s" : ""}</p>
          </div>

          <div className="space-y-0">
            {STEPS.map((s, i) => {
              const done = i <= idx;
              const Icon = s.icon;
              return (
                <div key={s.key} className="flex items-start gap-4" data-testid={`track-step-${s.key}`}>
                  <div className="flex flex-col items-center">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center border transition-colors ${done ? "bg-ink text-linen border-ink" : "bg-transparent text-ink/30 border-ink/20"}`}>
                      <Icon size={16} strokeWidth={1.5} />
                    </div>
                    {i < STEPS.length - 1 && <div className={`w-px h-12 ${i < idx ? "bg-ink" : "bg-ink/15"}`} />}
                  </div>
                  <div className="pt-2">
                    <p className={`font-body text-sm ${done ? "text-ink" : "text-ink/40"}`}>{s.label}</p>
                    {s.key === "shipped" && order.tracking_number && (
                      <p className="font-body text-xs text-ink/50 mt-1" data-testid="track-tracking-number">Tracking #: {order.tracking_number}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-16">
            <Link to="/shop" className="inline-block bg-ink text-linen font-body uppercase tracking-wide2 text-[0.65rem] px-8 py-3 hover:opacity-80 transition-opacity" data-testid="track-shop-link">
              Continue the Voyage
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
